import { Flex, Spin } from 'antd';
import React from 'react'

const Loading = () => {
     const sharedProps = {
    spinning: true,
    percent: 0,
  };
  const stylesObject = {
    indicator: {
      color: "#00d4ff",
    },
  };
  return (
   <div
        style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#808e9b",
        }}
      >
        <Flex align="center" gap="middle">
          <Spin {...sharedProps} styles={stylesObject} size="large" />
        </Flex>
      </div>
  )
}

export default Loading
